import { IQuestionModel } from '@care-portals/api-interfaces';

const options = [
  { key: '0', value: 'Not at all true' },
  { key: '1', value: 'Somewhat true' },
  { key: '2', value: 'Moderately true' },
  { key: '3', value: 'Very true' },
  { key: '4', value: 'Completely true' }
];

const questions = [
  'My therapist seemed warm,supportive,and concerned',
  'My therapist seemed trustworthy',
  'My therapist treated me with respect',
  'My therapist did a good job of listening',
  'My therapist understood how I felt inside',
  'I was able to express my feelings during the session',
  'I talked about the problems that are bothering me',
  'The techniques we used were helpful',
  'The approach my therapist used made sense',
  'I learned some new ways to deal with my problems',
  'I believe the session was helpful to me',
  "Overall, I was satisfied with today's session",
  'I plan to do therapy homework before the next session',
  "I intend to use what I learned in today's session",
  "At times, my therapist didn't seem to understand how I felt",
  'At times, I felt uncomfortable during the session',
  "I didn't always agree with my therapist",
  'It was hard to answer some of these questions honestly',
  "Some times my answers didn't show how I really felt inside",
  'It would be too upsetting for me to criticize my therapist'
];

const questionsModels: IQuestionModel[] = [
  {
    field: 'bms_after_intro',
    type: 'info',
    label:
      'Circle the answer to indicate how you felt about your most recent therapy session. Please answer all the items.',
    answer: {}
  },
  ...questions.map(
    (q, i) =>
      ({
        field: `bms_after_${i + 1}`,
        label: q,
        type: 'select',
        answer: {
          type: 'single_select',
          options
        }
      } as IQuestionModel)
  ),
  {
    label: 'What did you like the least about the session?',
    field: 'bms_after_least',
    type: 'info',
    answer: {
      type: 'text',
      name: 'bms_after_least_ans',
    }
  },
  {
    label: 'What did you like the best about the session?',
    field: 'bms_after_best',
    type: 'info',
    answer: {
      type: 'text',
      name: 'bms_after_best_ans',
    }
  },
];

export default questionsModels;
